import styled from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

export const Container = styled(Flex)<{ $isLoading?: boolean; $withRedirect?: boolean }>`
    padding: 8px;
    background: ${colorsPalettes.carbon[0]};
    gap: 12px;
    overflow: hidden;

    border-radius: 6px;

    transition: box-shadow 200ms ease;
    cursor: ${({ $withRedirect }) => ($withRedirect ? "pointer" : "default")};

    .webIcon {
        flex-shrink: 0;
    }

    &:hover {
        ${setElevation("Z1")};
    }

    ${({ $isLoading }) => $isLoading && "pointer-events: none"};
`;

export const IconContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;

    width: 32px;
    height: 32px;

    color: ${colorsPalettes.carbon[200]};
`;

export const IconLoader = styled(PixelPlaceholderLoader)`
    width: 32px;
    height: 32px;
    border-radius: 6px;
`;

export const ContentContainer = styled(Stack)`
    gap: 4px;
    overflow: hidden;
    flex: 1;
`;

export const Title = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colorsPalettes.carbon[500]};
`;

export const Content = styled.div`
    color: ${colorsPalettes.carbon[400]};

    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;

    ${setFontVariant("listItem3")};

    .item {
        ${setFontVariant("captionTitle")};
    }
`;
